<!--
  第五个区域：更多活动
  标题是文字，下面一张可点击的活动图（686x180@2x = 343x90）
-->
<script lang="ts">
  import { _ as t, locale } from "svelte-i18n";
  import birthdayUrlCn from "../assets/images/cn/birthday-url.png";
  import birthdayUrlTc from "../assets/images/tc/birthday-url.png";

  /** 简体用 cn 图，其余（繁体 / 英文 / 韩文 / 站外默认）用 tc 图 */
  let birthdayUrl = $derived($locale === "zh-cn" ? birthdayUrlCn : birthdayUrlTc);

  interface Props {
    /** 点击活动图 */
    onClick?: () => void;
  }

  let { onClick }: Props = $props();
</script>

<p class="more-title">{$t("more_activity")}</p>

<button type="button" class="block w-full mt-[8px]" onclick={onClick}>
  <img src={birthdayUrl} alt={$t("more_activity")} class="w-full block" />
</button>

<style>
  /* 标题（设计稿）：16px / 600 / line-height 24px / #FFFFFF */
  .more-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    color: #ffffff;
  }
</style>
